/* unplugin-vue-components disabled */import { render } from "./topay.vue?vue&type=template&id=1bc8befc&scoped=true"
import script from "./topay.vue?vue&type=script&lang=js"
export * from "./topay.vue?vue&type=script&lang=js"

import "./topay.vue?vue&type=style&index=0&id=1bc8befc&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc8befc"]])

export default __exports__